import { Route } from '@angular/router';
import { ECapabilities } from './account/domain/account.model';
import { authGuard } from './auth/infrastructure/auth.guard';
import { loginGuard } from './auth/infrastructure/login.guard';
import { AppSection } from './layout/app-navigation/domain/app-section.model';
// import { ECapabilities } from './account/domain/account.model';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AppSection.DASHBOARD,
  },
  {
    path: AppSection.DASHBOARD,
    loadChildren: () => import('./layout/pages/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
    canActivate: [authGuard], // versionGuard, authGuard
    data: {
      section: AppSection.DASHBOARD,
      requiredCapability: ECapabilities.AUTHENTICATED,
    }, // requiredCapability: ECapabilities.AUTHENTICATED
  },
  {
    path: AppSection.CRM,
    loadChildren: () => import('./layout/pages/crm/crm.routes').then((m) => m.CRM_ROUTES),
    canActivate: [authGuard], // versionGuard, authGuard
    data: {
      section: AppSection.CRM,
      requiredCapability: ECapabilities.AUTHENTICATED,
    }, // requiredCapability: ECapabilities.AUTHENTICATED
  },
  {
    path: AppSection.OPERATIONS,
    loadChildren: () => import('./layout/pages/operations/operations.routes').then((m) => m.OPERATIONS_ROUTES),
    canActivate: [authGuard], // versionGuard, authGuard
    data: {
      section: AppSection.OPERATIONS,
      requiredCapability: ECapabilities.AUTHENTICATED,
    }, // requiredCapability: ECapabilities.AUTHENTICATED
  },
  {
    path: AppSection.INCOME,
    loadChildren: () => import('./layout/pages/income/income.routes').then((m) => m.INCOME_ROUTES),
    canActivate: [authGuard], // versionGuard, authGuard
    data: {
      section: AppSection.INCOME,
      requiredCapability: ECapabilities.AUTHENTICATED,
    }, // requiredCapability: ECapabilities.AUTHENTICATED
  },
  {
    path: AppSection.OUTCOME,
    loadChildren: () => import('./layout/pages/outcome/outcome.routes').then((m) => m.OUTCOME_ROUTES),
    canActivate: [authGuard], // versionGuard, authGuard
    data: {
      section: AppSection.OUTCOME,
      requiredCapability: ECapabilities.AUTHENTICATED,
    }, // requiredCapability: ECapabilities.AUTHENTICATED
  },
  {
    path: AppSection.ADMIN,
    loadChildren: () => import('./layout/pages/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    canActivate: [authGuard], // versionGuard, authGuard
    data: {
      section: AppSection.ADMIN,
      requiredCapability: ECapabilities.AUTHENTICATED,
    }, // requiredCapability: ECapabilities.AUTHENTICATED
  },
  {
    path: 'login',
    loadComponent: () => import('./layout/pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [loginGuard], // versionGuard, authGuard
    data: {}, // requiredCapability: ECapabilities.AUTHENTICATED
  },

  // TODO remove, for dev purposes only
  {
    path: 'scaffolding',
    canActivate: [], // versionGuard, authGuard
    data: {}, // requiredCapability: ECapabilities.AUTHENTICATED
    children: [
      {
        path: '',
        loadComponent: () => import('./layout/pages/scaffolding/scaffolding.page').then((m) => m.ScaffoldingPage),
      },
      {
        path: 'colors',
        loadComponent: () => import('./layout/pages/scaffolding/colors/colors.page').then((m) => m.ColorsPage),
      },
      {
        path: 'buttons',
        loadComponent: () => import('./layout/pages/scaffolding/buttons/buttons.page').then((m) => m.ButtonsPage),
      },
      {
        path: 'cards',
        loadComponent: () => import('./layout/pages/scaffolding/cards/cards.page').then((m) => m.CardsPage),
      },
      {
        path: 'tags',
        loadComponent: () => import('./layout/pages/scaffolding/tags/tags.page').then((m) => m.TagsPage),
      },
    ],
  },
];
